import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-enterprise";
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import TextInput from '../../components/UIComponent/TextInput';
import TransactionReoprtServices from '../../services/axiosServices/apiServices/TransactionReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { SelectItemListPopUp } from '../../components/dropdown/SelectItemListPopUp';
import { getFinancialYearDates } from '../../utils/DateUtils';
import { encryptAES } from '../../utils/Encryption';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

ModuleRegistry.registerModules([AllCommunityModule]);

class ItemWisePendingReport extends Component {
    constructor(props) {
        super(props);
        this.transactionReoprtServices = new TransactionReoprtServices();
        this.SwalServices = new SwalServices();
        this.gridRef = React.createRef();
        this.state = {
            route: null,
            idCompany: null,
            rowData: [],
            colDefs: [
                { field: "drawingNo", headerName: "Drawing No", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.09, flex: 1 },
                { field: "searchText", headerName: "Search Text", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.09, flex: 1 },
                { field: "itemName", headerName: "Item Name", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.18, flex: 1.8 },
                { field: "party", headerName: "Party", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.12, flex: 1.2 },
                { field: "orderNo", headerName: "Order No", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.07, flex: 0.8 },
                { field: "orderDate", headerName: "Order Date", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.07, flex: 0.8 },
                { field: "pendingQty", headerName: "Pending Qty", filter: true, floatingFilter: true, minWidth: window.innerWidth * 0.07, flex: 0.7 },
            ],
            requestDetails: {
                type: 'WO',
                typeList: [
                    { value: 'WO', label: 'Work Order' },
                    { value: 'JW', label: 'Job Work' },
                    { value: 'PO', label: 'Purchase Order' },
                ],
                startDate: getFinancialYearDates().fromDate,
                endDate: getFinancialYearDates().toDate,
                idItem: "",
                itemIdLabel: "",
                itemList: [],
            },
            paginationPageSize: 50,
            rowHeight: 40,
            isSelectItemPopUp: false,
            selectItemColDefs: [
                { field: "itemCategory", headerName: "Item Category", minWidth: window.innerWidth * 0.06, flex: 0.6, filter: true, floatingFilter: true },
                { field: "searchText", headerName: "Search Text", minWidth: window.innerWidth * 0.05, flex: 0.5, filter: true, floatingFilter: true },
                { field: "drawingNo", headerName: "Drawing No", minWidth: window.innerWidth * 0.08, flex: 0.8, filter: true, floatingFilter: true },
                { field: "itemName", headerName: "Item Name", minWidth: window.innerWidth * 0.15, flex: 1.5, filter: true, floatingFilter: true },
            ],
        };
    }

    componentDidMount = () => {
        let prop = getAuthProps();
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.restoreAndLoad();
            });
        }
    }

    // restore last search (filters + rows) so browser-back returns to the same report state
    restoreAndLoad = () => {
        let details = this.state.requestDetails;
        let rowData = this.state.rowData;
        try {
            const saved = sessionStorage.getItem('itemWisePendingReportState');
            if (saved) {
                const s = JSON.parse(saved);
                details = {
                    ...details,
                    type: s.type,
                    startDate: s.startDate,
                    endDate: s.endDate,
                    idItem: s.idItem,
                    itemIdLabel: s.itemIdLabel,
                };
                rowData = s.rowData || [];
            }
        } catch (e) { /* ignore corrupt storage */ }
        this.setState({ requestDetails: details, rowData }, () => this.getPendingItems());
    }

    handleChange = (event, name) => {
        let details = this.state.requestDetails;
        details[name] = event.target.value;
        this.setState({ requestDetails: details });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.requestDetails;
        details[name] = event.value;
        this.setState({ requestDetails: details }, () => {
            if (name === "type") {
                // reset selected item and reload only pending items for the new type
                let d = this.state.requestDetails;
                d.idItem = "";
                d.itemIdLabel = "";
                this.setState({ requestDetails: d }, () => this.getPendingItems());
            }
        });
    }

    getPendingItems = () => {
        // load only items that have pending records for the selected type (WO/JW/PO)
        let request = {
            type: this.state.requestDetails.type,
            idCompany: this.state.idCompany,
        };
        this.transactionReoprtServices.getReportPendingItems(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let details = this.state.requestDetails;
                details.itemList = response.responseItem.responseContent || [];
                this.setState({ requestDetails: details });
            }
        });
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleOnClick = () => {
        this.setOpenModel2();
    }

    handleDropdownCellClick = (event) => {
        let details = this.state.requestDetails;
        details.idItem = event.data.idItem;
        details.itemIdLabel = event.data.itemName;
        this.setState({ requestDetails: details, isSelectItemPopUp: false });
    };

    getRecords = () => {
        const d = this.state.requestDetails;
        let request = {
            type: d.type,
            idCompany: this.state.idCompany,
            fromDate: d.startDate ? d.startDate : null,
            toDate: d.endDate ? d.endDate : null,
            idItem: d.idItem ? d.idItem : null,
        };
        this.transactionReoprtServices.getItemWisePendingReport(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = (response.responseItem.responseContent || []).map((x) => ({
                    ...x,
                    orderDate: x.orderDate ? moment(x.orderDate).format('DD-MM-YYYY') : ''
                }));
                this.setState({ rowData: data });
                try {
                    sessionStorage.setItem('itemWisePendingReportState', JSON.stringify({
                        type: d.type,
                        startDate: d.startDate,
                        endDate: d.endDate,
                        idItem: d.idItem,
                        itemIdLabel: d.itemIdLabel,
                        rowData: data,
                    }));
                } catch (e) { /* ignore storage quota / private mode */ }
            } else {
                this.SwalServices.Error(response.message);
            }
        });
    }

    onRowDoubleClicked = (event) => {
        let idOrder = event.data.idOrder;
        if (!idOrder) return;
        const enc = encryptAES(idOrder);
        const type = this.state.requestDetails.type;
        let path = '';
        if (type === 'WO') path = `/wo-receive?id=${enc}`;
        else if (type === 'JW') path = `/material-job-work?id=${enc}`;
        else if (type === 'PO') path = `/purchase-order?id=${enc}`;
        if (path) this.setState({ route: path });
    };

    getPinnedBottomRowData = () => {
        if (!this.state.rowData || this.state.rowData.length === 0) return [];
        const totalPending = this.state.rowData.reduce((sum, r) => sum + (Number(r.pendingQty) || 0), 0);
        return [{ drawingNo: "Total", searchText: "", itemName: "", party: "", orderNo: "", orderDate: "", pendingQty: totalPending }];
    }

    onExportExcel = () => {
        if (this.gridRef.current && this.gridRef.current.api) {
            const csvData = this.gridRef.current.api.getDataAsCsv();
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ItemWisePending_Report.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    onExportPdf = () => {
        if (!this.gridRef.current || !this.gridRef.current.api) return;
        const doc = new jsPDF();
        const d = this.state.requestDetails;
        const typeLabel = d.typeList.find(x => x.value === d.type)?.label || '';
        const pageWidth = doc.internal.pageSize.getWidth();
        const headerLines = [
            `Item Wise Pending - ${typeLabel}`,
            `From: ${d.startDate ? moment(d.startDate).format('DD-MM-YYYY') : '-'}  To: ${d.endDate ? moment(d.endDate).format('DD-MM-YYYY') : '-'}`,
        ];
        const lineHeight = 8, padding = 2;
        const totalHeaderHeight = headerLines.length * lineHeight + padding * 2;
        doc.setFillColor(245, 245, 245);
        doc.rect(0, 0, pageWidth, totalHeaderHeight, 'F');
        doc.setFontSize(12);
        doc.setTextColor(80, 80, 80);
        headerLines.forEach((line, i) => {
            const textWidth = doc.getTextWidth(line);
            doc.text(line, (pageWidth - textWidth) / 2, padding + (i + 1) * lineHeight - 2);
        });

        const cols = this.state.colDefs;
        const body = [];
        this.gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            body.push(cols.map(c => node.data[c.field]));
        });
        const pinnedCount = this.gridRef.current.api.getPinnedBottomRowCount();
        for (let i = 0; i < pinnedCount; i++) {
            const p = this.gridRef.current.api.getPinnedBottomRow(i);
            body.push(cols.map(c => p.data[c.field]));
        }

        autoTable(doc, {
            head: [cols.map(c => c.headerName)],
            body: body,
            startY: totalHeaderHeight + 4,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [63, 140, 255], textColor: 255 },
        });
        doc.save("ItemWisePending-report.pdf");
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='item-wise-pending-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select details</p>
                            <div className='item-set flex gap-[15px]'>
                                <div className='item-grp w-full grid grid-cols-6 gap-[15px] items-start'>
                                    <div className='input-grp'>
                                        <label>Type</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Type"
                                            options={this.state.requestDetails.typeList}
                                            value={this.state.requestDetails.type ? this.state.requestDetails.typeList.find(x => x.value === this.state.requestDetails.type) : 0}
                                            onChange={(event) => this.handleChangeForDropdown(event, "type")}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>From Date</label>
                                        <TextInput type="date" id="startDate" name="startDate"
                                            value={this.state.requestDetails.startDate}
                                            handleChange={(event) => this.handleChange(event, "startDate")} />
                                    </div>
                                    <div className="input-grp">
                                        <label>To Date</label>
                                        <TextInput type="date" id="endDate" name="endDate"
                                            value={this.state.requestDetails.endDate}
                                            handleChange={(event) => this.handleChange(event, "endDate")} />
                                    </div>
                                    <div className='input-grp w-full col-span-2'>
                                        <label>Select item (optional)</label>
                                        <TextInput
                                            id="SelectItem"
                                            name="SelectItem"
                                            value={this.state.requestDetails.itemIdLabel}
                                            handleOnClick={(event) => this.handleOnClick(event, "itemList")}
                                        />
                                    </div>
                                    <div className='btn-grp'>
                                        <button onClick={() => this.getRecords()} className='prm-btn'>Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table w-full cursor-default bg-white shadow-normalShadow rounded-[10px] pb-[50px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[56vh] w-full rounded-[5px]">
                                <div className="table-inner flex items-center justify-between mb-2">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item wise pending</h1>
                                    {this.state.rowData.length > 0 ?
                                        <div className='btn-grp flex items-center gap-2.5'>
                                            <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]'
                                                onClick={() => this.onExportExcel()}>Export to Excel</button>
                                            <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]'
                                                onClick={() => this.onExportPdf()}>Export to PDF</button>
                                        </div>
                                        : null}
                                </div>
                                <AgGridReact
                                    ref={this.gridRef}
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    pinnedBottomRowData={this.getPinnedBottomRowData()}
                                    rowClassRules={{ "sum-row": (params) => params.node.rowPinned === "bottom" }}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.requestDetails.itemList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
            </div>
        );
    }
}

export default ItemWisePendingReport;
